/*
 * THE WIDGET KIT — shared drawing helpers, asked for by version.
 *
 * `kit(n)` inside a widget returns version n's helpers, built fresh for that widget: the helpers keep
 * small pieces of state (whether the box is compact, how wide a plot's axis labels have grown), and
 * two widgets must never share them. Versions are frozen (see kit-v1.ts); an unknown one throws, so a
 * widget written against a kit this runtime does not have fails loudly on load instead of drawing
 * something else.
 */
import * as sdk from './sdk';
import { KIT_V1_BODY, KIT_V1_NAMES } from './kit-v1';

const BODIES: Record<number, string> = { 1: KIT_V1_BODY };

/** The newest kit. A new widget should ask for this one. */
export const KIT_LATEST = 1;

/** Build one instance of kit `version`. */
export function kit(version: number): Readonly<Record<string, unknown>> {
  const body = BODIES[version];
  if (!body) throw new Error(`kit(${version}) does not exist; this runtime has kit 1 to ${KIT_LATEST}`);
  return new Function('el', 'clamp', 'lerp', 'remap', 'normalize', 'polar', 'arc', 'fixed', body)(
    sdk.el, sdk.clamp, sdk.lerp, sdk.remap, sdk.normalize, sdk.polar, sdk.arc, sdk.fixed,
  ) as Readonly<Record<string, unknown>>;
}

/** The first line of a widget written against kit 1: the kit, and every helper by name. */
export const KIT_V1_HEADER = `const ui = kit(1);\nconst { ${KIT_V1_NAMES.join(', ')} } = ui;\n`;
